import { render, staticRenderFns } from "./newsMessage.vue?vue&type=template&id=5ca81990&"
import script from "./newsMessage.vue?vue&type=script&lang=js&"
export * from "./newsMessage.vue?vue&type=script&lang=js&"
import style0 from "./newsMessage.vue?vue&type=style&index=0&id=5ca81990&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports